export const SET_SELECTED_MICROZONE = 'SET_SELECTED_MICROZONE';
export const GET_MICROZONES = 'GET_MICROZONES';
export const SET_MICROZONES = 'SET_MICROZONES';
export const SET_ZONE_PROPS = 'SET_ZONE_PROPS';
export const HOVER_ZONE = 'HOVER_ZONE';
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_SELECTED_TYPE_ACTION = 'SET_SELECTED_TYPE_ACTION';
export const SET_WHIM_DATA = 'SET_WHIM_DATA';
